/**
 * @param number
 * @returns the number if the number is not NaN, 0 if the number is NaN
 */

const handleNaN = (number: number) => (isNaN(number) ? 0 : number);

export default handleNaN;
